/** @jsx jsx */
/** @jsxRuntime classic */
import { Auth, Meta } from '@elevio/kb-kit/lib/components';
import { css, jsx } from '@emotion/react';
import { Search } from '../components';
import { toRem } from '../functions';
import { Footer, MainError, Nav, Page } from '../layout';
import { errorTitleCSS, textLargeCSS } from '../variables';
// TYPES
const titleCSS = css([errorTitleCSS, {
        color: 'var(--textStrong)',
        marginBlockEnd: toRem(32),
        textAlign: 'center',
    }]);
const messageCSS = css([textLargeCSS, {
        color: 'var(--textDefault)',
        marginBlockEnd: toRem(32),
        textAlign: 'center',
    }]);
const linkCSS = css({
    color: 'var(--accent)',
    fontWeight: 600,
    outline: 'none',
    textDecoration: 'underline',
    transitionProperty: 'opacity',
    transitionDuration: '200ms',
    transitionTimingFunction: 'cubic-bezier(0,0,0,.4)',
    '&:hover': {
        opacity: .75,
    },
    '&:active': {
        opacity: .5,
    },
    '&:focus': {
        borderRadius: toRem(4),
        boxShadow: `0 0 0 ${toRem(2)} var(--accent)`,
        marginInlineStart: toRem(-2),
        marginInlineEnd: toRem(-2),
        paddingInlineStart: toRem(2),
        paddingInlineEnd: toRem(2),
    },
});
// FUNCTIONS
export default function ErrorPage() {
    return (<Page>
            <Nav hideSearch/>
            <MainError>
                <h1 css={titleCSS}>Page Not Found</h1>
                <p css={messageCSS}>The page your were looking for may have been move or deleted, or have restrcited access.</p>
                <p css={messageCSS}>You could try to <Auth.LoginLogoutLink loginChildren="log in" logoutChildren="log out" css={linkCSS}/>, go to the <Meta.HomeLink css={linkCSS}>home page</Meta.HomeLink> or search below.</p>
                <Search large/>
            </MainError>
            <Footer />
        </Page>);
}
